export default {
  NEWS_ITEMS: 'NEWS_ITEMS',
  ITEMS_ENDS: 'ITEMS_ENDS',
};
